import { onRender, removeElement } from './helpers';

class Tooltips {
  init() {
    const targets = [...document.querySelectorAll('.js-tooltip')];
    targets.forEach((target, index) => this.bindTooltip(target, index));
  }

  /**
   * @param {HTMLElement} target
   * @param {Number} index
   */
  bindTooltip(target, index) {
    if (!target.getAttribute('data-for')) {
      // target.addEventListener('click', () => {
      //   if (target.getAttribute('data-visible') === 'true') {
      //     this.hideTooltip(target, index);
      //   } else {
      //     this.showTooltip(target, index);
      //   }
      // });

      target.addEventListener('mouseenter', () => {
        this.showTooltip(target, index);
      });
      target.addEventListener('mouseleave', () => {
        this.hideTooltip(target, index);
      });

      target.setAttribute('data-for', 'tooltip' + index);
      target.setAttribute('data-visible', false);
    }
  }

  /**
   * @param {String} content
   * @param {Number} index
   */
  createTooltip(content, index) {
    const tooltip = document.createElement('div');
    tooltip.classList.add('tooltip');
    tooltip.setAttribute('id', 'tooltip' + index);
    tooltip.innerHTML = content;
    return tooltip;
  }

  /**
   * @param {HTMLElement} target
   * @param {Number} index
   */
  showTooltip(target, index) {
    const content = target.querySelector('.tooltip-content').innerHTML;
    const tooltip = document.body.appendChild(
      this.createTooltip(content, index),
    );
    target.setAttribute('data-visible', true);
    onRender(tooltip, () => {
      const offset = this.calcOffset(target, tooltip);
      tooltip.style.top = offset.top + 'px';
      tooltip.style.left = offset.left + 'px';
      tooltip.classList.add('visible');
    });
  }

  /**
   * @param {ElemHTMLElementent} target
   */
  hideTooltip(target) {
    target.setAttribute('data-visible', false);
    const tooltip = document.getElementById(target.getAttribute('data-for'));
    if (tooltip) {
      requestAnimationFrame(() => removeElement(tooltip));
    }
  }

  /**
   * @param {HTMLElement} target
   * @param {HTMLElement} tooltip
   * @returns {Object} - a set of dimensions
   */
  calcInitial(target, tooltip) {
    // initial DOM element values
    const rect = {
      target: target.getBoundingClientRect(),
      tooltip: tooltip.getBoundingClientRect(),
      body: document.body.getBoundingClientRect(),
    };

    return rect;
  }

  /**
   * @param {HTMLElement} target
   * @param {HTMLElement} tooltip
   * @returns {Object} offset
   */
  calcOffset(target, tooltip) {
    const rect = this.calcInitial(target, tooltip);

    // Final tooltip coordinates
    const offset = {
      top: rect.target.top - rect.body.top - rect.tooltip.height - 10,
      left:
        rect.target.left + rect.target.width / 2 - rect.tooltip.width / 2 - 12,
    };

    if (offset.top <= Math.abs(rect.body.top) + 10) {
      offset.top += rect.tooltip.height + rect.target.height + 16;
    }
    if (rect.tooltip.width + offset.left >= rect.body.width) {
      offset.left = rect.body.width - rect.tooltip.width;
    }
    if (offset.left < 0) {
      offset.left = 0;
    }

    return offset;
  }
}

// export default new Tooltips();
export const tooltips = new Tooltips();



// WEBPACK FOOTER //
// ./src/js/tooltips.js